/* temporary types */
import { User, AuthPermission, PermissionScope, AuthScope } from '@bechtel/types';
export interface UserRight {
  rightName: string;
  //accessLevel: number;
}

export interface AppUser extends User {
  rights?: UserRight[];
}

export interface AppUserProps {
  user: AppUser | null;
  hasRight: (rightName: string) => boolean;
  hasPermissionAndScope: (permission: AuthPermission, scope: AuthScope) => boolean;
  hasPermissionScope: (permissionScope: PermissionScope) => boolean;
  hasAllPermissionScopes: (permissionScopes: PermissionScope[]) => boolean;
}
